module.exports = __webpack_public_path__ + "static/media/organon.caa7505e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/organon.png
// module id = 124
// module chunks = 0